// Configuration de l'API
export const apiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 120000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
}

// URL de base pour les fichiers stockés
export const storageURL = import.meta.env.VITE_STORAGE_URL

/**
 * Normalise n'importe quel chemin de fichier vers l'URL de storage locale.
 * Gère les 3 cas renvoyés par l'API :
 *  - chemin relatif        : "posts/abc.jpg"                         → storageURL + "/posts/abc.jpg"
 *  - URL complète (bon/mauvais hôte) : "http://x:84/storage/posts/abc.jpg" → storageURL + "/posts/abc.jpg"
 *  - null / vide           : → null
 * Évite ainsi le doublage d'URL et l'hôte codé en dur côté backend.
 */
export const mediaUrl = (path) => {
  if (!path) return null
  let s = String(path)
  const i = s.indexOf('/storage/')
  if (i !== -1) s = s.slice(i + 9) // garde uniquement la partie après "/storage/"
  return storageURL + '/' + s.replace(/^\/+/, '')
}

// Configuration de l'application
export const appConfig = {
  name: import.meta.env.VITE_APP_NAME || 'Kudhi',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  env: import.meta.env.VITE_APP_ENV || 'development',
}

// Clés de stockage
export const storageKeys = {
  authToken: import.meta.env.VITE_AUTH_TOKEN_KEY || 'kudhi_auth_token',
  refreshToken: import.meta.env.VITE_REFRESH_TOKEN_KEY || 'kudhi_refresh_token',
  user: 'kudhi_user',
  theme: 'kudhi_theme',
}

// Feature flags
export const features = {
  enableNotifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS === 'true',
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
}

export default {
  api: apiConfig,
  storage: storageKeys,
  storageURL,
  app: appConfig,
  features,
}
